var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmex1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 6,
    fill: "#1F72CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70859 9L6 14.9923H9.24257L9.64455 14.0369H10.5634L10.9654 14.9923H14.5345V14.2631L14.8526 14.9923H16.6988L17.0169 14.2477V14.9923H24.4397L25.3423 14.0617L26.1875 14.9923L30 15L27.2829 12.0129L30 9H26.2466L25.368 9.91341L24.5494 9H16.4743L15.7809 10.5467L15.0712 9H11.8354V9.7044L11.4755 9H8.70859ZM19.7933 9.85098H24.0559L25.3596 11.2588L26.7054 9.85098H28.0091L26.0282 12.0121L28.0091 14.1483H26.6462L25.3425 12.7241L23.9899 14.1483H19.7933V9.85098ZM20.8458 11.5262V10.7413V10.7405H23.5055L24.6661 11.9958L23.4541 13.258H20.8458V12.4011H23.1712V11.5262H20.8458ZM9.3361 9.85098H10.9167L12.7133 13.9144V9.85098H14.4448L15.8324 12.7644L17.1113 9.85098H18.8341V14.1508H17.7858L17.7773 10.7815L16.249 14.1508H15.3112L13.7744 10.7815V14.1508H11.6178L11.209 13.1869H9.00011L8.59211 14.15H7.43665L9.3361 9.85098ZM9.3772 12.2956L10.1047 10.5784L10.8314 12.2956H9.3772Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex1);
export default __webpack_public_path__ + "static/media/amex1.6848ba4640c0aa6c3cbb4307df3560ee.svg";
export { ForwardRef as ReactComponent };